import React, { Fragment } from 'react'
import { Grid, Card } from 'semantic-ui-react'
import { getHTMLFromEditorState } from '../../utils/helpers'

const ExpertExpertise = ({ expert }) => {
    const summary =
        expert.expert.infoFromLinkedin &&
        expert.expert.infoFromLinkedin !== 'NaN'
            ? expert.expert.infoFromLinkedin
            : expert.expert.description

    return (
        <Grid.Row>
            {summary ? (
                <Fragment>
                    <span>About the expert</span>
                    <br />
                    <div className="summary-container">
                        <Card fluid>
                            <Card.Content>
                                <Card.Description className="expertise-summary">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: getHTMLFromEditorState(
                                                summary
                                            ),
                                        }}
                                    ></div>
                                </Card.Description>
                            </Card.Content>
                        </Card>
                    </div>
                </Fragment>
            ) : null}
        </Grid.Row>
    )
}

export default ExpertExpertise
